/* global _TL_ */
/*eslint new-cap:0 */
import ko from 'knockout';
import _ from 'underscore';
import bidRangeExtension from '@bingads-webui-campaign-legacy/adgroup-create-advanced/viewmodel/bidRangeExtension';
import { isBidLessThanFiveCentsForShoppingCampaign } from '@bingads-webui-campaign-legacy/adgroup-create-advanced/util/bidLessThanFiveCents';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';
import { defaultBid } from '@bingads-webui-campaign-legacy/budget/shared/defaultBid';

const s$AdGroup = window.globalLegacySchema.get('AdGroup');
const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const bidStatusENUM = {
  Error: 'error',
  Warning: 'warning',
  Good: 'ok',
};

export default class ViewModel {
  constructor({
    adgroup = undefined,
    isInKeywordCreationWorkflow = false,
    campaign,
    newI18n,
    activityLogger,
    AdGroupLogId,
    defaultBidValue = null,
    isMSStoreAdsGAWorkflow = false,
  } = {}) {
    this.activityLogger = activityLogger;
    this.editMode = !_.isUndefined(adgroup) || isInKeywordCreationWorkflow;
    this.suggestedBid = ko.observable(0);
    this.bidStatusENUM = bidStatusENUM;
    this.suggestedBidNew = ko.observable(0);
    this.applyBidBtnText = newI18n.getString(_TL_('Apply'));
    this.suggestedBidRequestId = ko.observable();
    this.showLowerThanMinSuggestionBidWarning = ko.observable(false);

    let SearchBid = this.editMode ? _.result(adgroup, 'SearchBid') : defaultBid();

    if (defaultBidValue != null) {
      SearchBid = defaultBidValue;
    }

    koSchema.properties(this, s$AdGroup, ['SearchBid'], {
      SearchBid,
    });

    this.bidTooLow = ko.computed(() => {
      return this.SearchBid() < this.suggestedBid();
    }, this);

    if (isBidLessThanFiveCentsForShoppingCampaign()) {
      bidRangeExtension.extend(this, ['SearchBid'], true, isMSStoreAdsGAWorkflow);
    } else {
      bidRangeExtension.extend(this, ['SearchBid'], false, isMSStoreAdsGAWorkflow);
    }

    this.showEstimation = ko.observable(false);
    this.Clicks = ko.observable();
    this.Impressions = ko.observable();
    this.ClicksNum = ko.observable(0);
    this.ImpressionsNum = ko.observable(0);
    this.SuggestedClicks = ko.observable(0);
    this.SuggestedImpressions = ko.observable(0);
    this.Spend = ko.observable();
    this.isBidChanged = ko.observable(false);
    this.bidLandscapeAvailable = ko.observable(false);
    this.moreImpressionsBySuggestion = ko.computed(() => {
      return Math.round(this.SuggestedImpressions() - this.ImpressionsNum());
    }, this);
    this.moreClicksBySuggestion = ko.computed(() => {
      return Math.round(this.SuggestedClicks() - this.ClicksNum());
    }, this);
    this.showLowBidWarning = ko.computed(() => {
      const isShowLowBidWarning = this.moreClicksBySuggestion() > 0 && this.moreImpressionsBySuggestion() > 0 &&
      this.SearchBid() < this.suggestedBidNew() / 2;

      if (isShowLowBidWarning && this.activityLogger) {
        this.activityLogger.signal(JSON.stringify({
          Scenario: 'AdgroupCreation',
          SuggestedBid: this.suggestedBidNew(),
          InputBid: this.SearchBid(),
          EventName: 'CreationFlowLowBidAlertShow',
          LowBidAlertType: 'Critical',
          SuggestedBidRequestId: this.suggestedBidRequestId(),
          CampaignId: campaign.Id,
          AdGroupLogId,
        }), 'lowBidWarning');
      }
      return isShowLowBidWarning;
    }, this);

    this.showLowBidInfo = ko.computed(() => {
      const isShowLowBidInfo = this.moreClicksBySuggestion() > 0 && this.moreImpressionsBySuggestion() > 0 &&
      this.SearchBid() >= this.suggestedBidNew() / 2 && this.SearchBid() < this.suggestedBidNew();

      if (isShowLowBidInfo && this.activityLogger) {
        this.activityLogger.signal(JSON.stringify({
          Scenario: 'AdgroupCreation',
          SuggestedBid: this.suggestedBidNew(),
          InputBid: this.SearchBid(),
          EventName: 'CreationFlowLowBidAlertShow',
          LowBidAlertType: 'Normal',
          SuggestedBidRequestId: this.suggestedBidRequestId(),
          CampaignId: campaign.Id,
          AdGroupLogId,
        }), 'lowBidInfo');
      }

      return isShowLowBidInfo;
    }, this);
    this.lowBidWarning = ko.computed(() => {
      return newI18n.getString(
        _TL_('The recommended bid is {{bid}}. You could get {{impressions}} more impressions and {{clicks}} more clicks if you apply.'),
        {
          bid: this.suggestedBidNew(),
          impressions: this.moreImpressionsBySuggestion(),
          clicks: this.moreClicksBySuggestion(),
        },
      );
    });
    this.lowBidInfo = ko.computed(() => {
      return newI18n.getString(
        _TL_('You could get {{impressions}} more impressions and {{clicks}} more clicks if you adjust the bid to {{bid}}.'),
        {
          bid: this.suggestedBidNew(),
          impressions: this.moreImpressionsBySuggestion(),
          clicks: this.moreClicksBySuggestion(),
        },
      );
    });

    this.infoMessage = ko.observable('');
    this.showInfo = ko.computed(() => {
      return !_.isEmpty(this.infoMessage());
    }, this);

    this.estimateBtnText = ko.observable(i18n.get('Estimate_SearchTraffic'));
    this.showEstimateButton = ko.observable(false);

    this.disableSearchBid = ko.observable(false);
    this.isAutoBidding = ko.observable(false);

    this.searchBidErrorMessage = ko.computed(() => {
      const isValid = !_.isNull(this.SearchBid());

      return isValid ? '' : i18n.get('Validation_BidRequired');
    }, this);

    this.searchBidInvalid = ko.computed(() => {
      return !this.SearchBid.isValid() || !_.isEmpty(this.searchBidErrorMessage());
    }, this);
    this.bidStatus = ko.computed(() => {
      if (this.searchBidInvalid()) {
        return bidStatusENUM.Error;
      } else if (this.bidTooLow()) {
        return bidStatusENUM.Warning;
      } else {
        return bidStatusENUM.Good;
      }
    });
  }

  // eslint-disable-next-line no-empty-function
  updateAdGroupMedium() {
  }

  updateEstimations(data) {
    if (_.isEmpty(data.value)) {
      this.showEstError();
      this.showEstimation(false);
    }

    const est = _.property('AdGroupEstimatedTraffic')(_.first(data.value));

    if (_.isEmpty(est)) {
      this.showEstError();
      this.showEstimation(false);
    } else {
      this.showEstimation(true);
      this.Clicks(decimal.fromFloatToString(est.Clicks, 0));
      this.Impressions(decimal.fromFloatToString(est.Impressions, 0));
      this.Spend(decimal.fromFloatToString(est.TotalCost, 0));
      this.ClicksNum(est.Clicks);
      this.ImpressionsNum(est.Impressions);
      this.estimateBtnText(i18n.get('Estimate_SearchTraffic_Refresh'));
    }
  }

  roundToTwo(num) {
    return +`${Math.round(`${num}e+2`)}e-2`;
  }

  showEstError(message) {
    const finalMessage = _.isString(message) ? message : i18n.get('Budget_TrafficEstimation_RequestError');

    this.errors.add([finalMessage]);
  }
}
